import { dataProvider } from "./dataProvider";

export const IS_ENV_DEVELOPMENT = process.env.NODE_ENV === "development";

// Backend host keyed by REACT_APP_ENV. Only consulted when running on localhost,
// where there is no deployed admin hostname to infer the target from.
const API_HOSTS_BY_ENV = {
  LOCAL: "http://localhost:8080",
  DEV: "https://diving-dev.scoresandmore.live",
  QA: "https://diving-qa.scoresandmore.live",
  PROD: "https://diving.scoresandmore.live",
};

// Deployed admin frontend host -> backend host. This is the source of truth for
// a built app: the backend follows the URL you are visiting, so one image behaves
// correctly in every environment regardless of the REACT_APP_ENV baked at build.
const API_HOSTS_BY_ADMIN_HOST = {
  "diving-admin.scoresandmore.live": "https://diving.scoresandmore.live",
  "diving-qa-admin.scoresandmore.live": "https://diving-qa.scoresandmore.live",
  "diving-dev-admin.scoresandmore.live": "https://diving-dev.scoresandmore.live",
};

const resolveApiHostFromEnv = () => {
  const rawEnv = process.env.REACT_APP_ENV || "LOCAL";
  const env = String(rawEnv).trim().toUpperCase();
  return API_HOSTS_BY_ENV[env] || API_HOSTS_BY_ENV.LOCAL;
};

const resolveApiHost = () => {
  // Deployed builds: choose the backend from the host in the address bar.
  if (typeof window !== "undefined" && window.location) {
    const mapped = API_HOSTS_BY_ADMIN_HOST[window.location.hostname];
    if (mapped) return mapped;
  }
  // localhost (or any unrecognized host): fall back to REACT_APP_ENV.
  return resolveApiHostFromEnv();
};

// Local dev server proxies /restapi (target from src/setupProxy.js).
// Built app calls the absolute backend host chosen by the current admin hostname.
export const API_URL = IS_ENV_DEVELOPMENT
  ? "/restapi"
  : `${resolveApiHost()}/restapi`;

const Provider = dataProvider(API_URL);

export const getList = (endpoint, params) => Provider.getList(endpoint, params);

export const deleteOne = (endpoint) => Provider.delete(endpoint);

export const create = (endpoint, data) => Provider.create(endpoint, data);

export const update = (endpoint, data) => Provider.update(endpoint, data);
